import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=762c4f48&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762c4f48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('762c4f48')) {
      api.createRecord('762c4f48', component.options)
    } else {
      api.reload('762c4f48', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=762c4f48&scoped=true&", function () {
      api.rerender('762c4f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/profile/profile.vue"
export default component.exports